import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aniversario',
  templateUrl: './aniversario.component.html',
  styleUrls: ['./aniversario.component.css']
})
export class AniversarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
